/** CTA（遷移先URLと文言）の組。どちらも未設定なら null / undefined。 */
export type CtaFields = {
  ctaUrl?: string | null
  ctaLabel?: string | null
}

/** 解決後の CTA。ラベルが null のときの既定文言（「採用情報へ」）は表示側で補う。 */
export type ResolvedCta = {
  ctaUrl: string | null
  ctaLabel: string | null
}

/**
 * 動画CTA とプレイリスト共通CTA から、実際に表示する CTA を決める（ADR-0019）。
 *
 * - 動画CTA（動画ライブラリの個別設定）が設定されていればプレイリスト共通CTA より優先する（動画勝ち）。
 *   プレイリスト共通CTA は「個別設定のない動画に使う既定値」。
 * - URL とラベルは出所でペアを揃える。動画の URL にプレイリストのラベルが混ざる解決はしない。
 * - どちらも未設定なら URL は null（ボタン非表示）。
 *
 * 埋め込みの SLIDER/TILE モーダルと、プレイリスト文脈（`?from=`）付きの動画詳細ページで
 * 同じ優先順位になるよう、解決ロジックはここに一元化する。
 *
 * @param playlistCta プレイリスト共通CTA（SLIDER/TILE 以外の面や文脈なしのときは null）
 * @param videoCta 動画CTA（動画ライブラリで設定）
 */
export function resolveEffectiveCta(
  playlistCta: CtaFields | null | undefined,
  videoCta: CtaFields | null | undefined,
): ResolvedCta {
  if (videoCta?.ctaUrl) {
    return { ctaUrl: videoCta.ctaUrl, ctaLabel: videoCta.ctaLabel || null }
  }
  if (playlistCta?.ctaUrl) {
    return { ctaUrl: playlistCta.ctaUrl, ctaLabel: playlistCta.ctaLabel || null }
  }
  return { ctaUrl: null, ctaLabel: null }
}
